import { takeEvery, put } from 'redux-saga/effects';
import { ActionPayload, actions } from '../slices/user';
import { userManager } from '@/helpers/user/ContensisUserManager';

export const UserSagas = [
  loginUser({ type: 'user/LOGIN_USER', payload: { init: true } }),
  takeEvery('user/LOGIN_USER', loginUser),
  takeEvery('user/LOGOUT_USER', logoutUser),
];

function* loginUser({ payload }: ActionPayload<'LOGIN_USER'>) {
  if ('init' in payload) {
    yield userManager.InitLogin();
    yield put(actions.SET_HAS_INITIALISED({ hasInitialised: true }));
  } else if ('username' in payload || 'sso' in payload) {
    const method = 'method' in payload ? payload.method || 'redirect' : 'redirect';
    yield userManager.Login(payload, method);
  } else userManager.error = new Error(`No credentials supplied`);

  const { user, error } = userManager;
  if (error) yield put(actions.LOGIN_FAILED(error.message));
  if (user)
    yield put(
      actions.LOGIN_COMPLETE({
        user,
        clientCredentials: userManager.credentials.toJSON(),
      })
    );
}

function* logoutUser() {
  // TODO: track sso in state and control logout style using this
  yield put(actions.SET_HAS_INITIALISED({ hasInitialised: true }));
  yield userManager.Logout();
}
